export default __webpack_public_path__ + "static/single-blog-bg-main-1e6ac4f3c7ae7a78b1ae7390923497a2.jpg";